<template>
  <span class="toggle-switch d-flex align-items-start">
    <input
      :id="id ?? randomId"
      type="checkbox"
      :checked="modelValue"
      @change="onChange"
      :data-testid="testId ?? 'toggle-switch'"
    />
    <label :for="id ?? randomId"></label>
    <span class="label left-label">{{ leftLabel }}</span>
    <span class="label right-label">{{ rightLabel }}</span>
  </span>
</template>

<script lang="ts" setup>
defineProps<{
  modelValue: boolean
  leftLabel: string
  rightLabel: string
  id?: string
  testId?: string
}>()

const emit = defineEmits<(e: 'update:modelValue', value: boolean) => void>()

const randomId = `toggle-${Math.random().toString(36).substring(2, 9)}`

const onChange = (event: Event) => {
  const target = event.target as HTMLInputElement | null
  if (target) {
    emit('update:modelValue', target.checked)
  }
}
</script>

<style scoped>
.toggle-switch {
  position: relative;
  width: 16.5rem;
  height: 3.125rem;
}

.toggle-switch input {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
  height: 100%;
  border-radius: 0.625rem;
  outline: none;
  border: 0.5px solid var(--ch-blue-100);
  cursor: pointer;
}

.toggle-switch label {
  position: absolute;
  z-index: 1;
  top: 5px;
  bottom: 5px;
  left: 6px;
  right: calc(50% - 6px);
  background: var(--ch-blue-100);
  border-radius: 0.625rem;
  transition: left 0.3s, right 0.4s 0.2s;
  -webkit-transition: left 0.3s, right 0.4s 0.2s;
  -o-transition: left 0.3s, right 0.4s 0.2s;
  cursor: pointer;
}

.toggle-switch input:checked + label {
  left: calc(50% - 6px);
  right: 6px;
  transition: left 0.4s 0.2s, right 0.5s;
  -webkit-transition: left 0.4s 0.2s, right 0.5s;
  -o-transition: left 0.4s 0.2s, right 0.5s;
}

.label {
  position: absolute;
  top: 50%;
  z-index: 1;
  font-size: var(--font-sm);
  font-weight: 400;
  line-height: 100%;
  white-space: nowrap;
  pointer-events: none;
  transition: color 0.2s, letter-spacing 0.2s;
  -webkit-transition: color 0.2s, letter-spacing 0.2s;
  -o-transition: color 0.2s, letter-spacing 0.2s;
}

.left-label {
  left: calc(25% + 6px);
  transform: translate(-50%, -50%);
  color: var(--ch-white);
  letter-spacing: -2%;
}

.right-label {
  left: calc(75% - 6px);
  transform: translate(-50%, -50%);
  color: #00000059;
  letter-spacing: -3%;
}

input:checked ~ .left-label {
  color: #00000059;
  letter-spacing: -3%;
}

input:checked ~ .right-label {
  color: var(--ch-white);
  letter-spacing: -2%;
}
</style>